import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ViToastService } from '@vi-iot/ui';

import { ZIGBEE_COORDINATOR_STATUS } from '../commissioning/commissioning.model';

import { COMMISSIONING_STATUSES } from './commissioning-statuses';

@Injectable({
  providedIn: 'root',
})
export class CommissioningMessageService {
  constructor(private translateService: TranslateService, private toastService: ViToastService) {}

  toast(status: ZIGBEE_COORDINATOR_STATUS): void {
    switch (COMMISSIONING_STATUSES[status].type) {
      case 'error':
        this.error(COMMISSIONING_STATUSES[status].messageKey);
        break;

      case 'info':
        this.info(COMMISSIONING_STATUSES[status].messageKey);
        break;

      case 'success':
        this.success(COMMISSIONING_STATUSES[status].messageKey);
        break;
    }
  }

  private error(messageKey: string): void {
    const message = this.translateService.instant(messageKey);
    this.toastService.error(
      { message },
      {
        duration: 3500,
      }
    );
  }

  private info(messageKey: string): void {
    const message = this.translateService.instant(messageKey);
    this.toastService.info(
      { message },
      {
        duration: 3500,
      }
    );
  }

  private success(messageKey: string): void {
    const message = this.translateService.instant(messageKey);
    this.toastService.info(
      { message },
      {
        duration: 3500,
      }
    );
  }
}
